import { useOktaAuth } from '@okta/okta-react';
import { useMemo } from "react";

export default function useAuthFetch() {
    const { authState } = useOktaAuth();
    const accessToken = authState?.accessToken?.accessToken;
    const idToken = authState?.idToken?.idToken;

    return useMemo(() => {
        const authFetch = (resource, options) => {
            const allOptions = options || {};
            const allHeaders = allOptions.headers || {};
            allHeaders.authorization = `Bearer ${accessToken}`
            if (idToken) {
                allHeaders['X-Id-Token'] = idToken;
            }
            allOptions.headers = allHeaders;

            return fetch(resource, allOptions);
        };

        // Identifies the credentials this closure sends. Callers that cache requests key on
        // it, so a request issued under a pre-refresh token is never handed to a caller that
        // has already been given the rotated one. Every component calls useAuthFetch()
        // separately and so gets its own closure -- the token pair, not closure identity, is
        // what makes two callers genuinely interchangeable.
        authFetch.authKey = `${accessToken ?? ""}|${idToken ?? ""}`;

        return authFetch;
    }, [accessToken, idToken]);
}